import { CommonModule } from '@angular/common';
import { booleanAttribute, Component, computed, effect, input, signal } from '@angular/core';
import { HumanizePipe } from '../../pipes/humanize.pipe';
import { AllStatus } from '../../types/all-status.type';

@Component({
  selector: 'status-chip',
  imports: [CommonModule, HumanizePipe],
  template: `
    <div
      class="status-chip"
      [class.small-chip]="smallChip()"
      [class.px-12]="hasExtraPadding()"
      [ngClass]="chipClasses()">
      {{ status() | humanize }}
    </div>
  `
})
export class StatusChipComponent {
  status = input.required<AllStatus | string>();
  smallChip = input(false, { transform: booleanAttribute });
  hasExtraPadding = input(false, { transform: booleanAttribute });

  backgroundColor = signal('bg-charcoal-50');
  textColor = signal('text-white!');

  chipClasses = computed(() => ({
    [this.backgroundColor()]: !!this.backgroundColor(),
    [this.textColor()]: !!this.textColor()
  }));

  constructor() {
    effect(() => {
      const statusValue = this.status();
      switch (statusValue) {
        case 'ASSESSED':
        case 'MIGRATED':
          this.backgroundColor.set('bg-charcoal-10');
          this.textColor.set('text-white!');
          break;
        case 'ACTIVE':
        case 'APPROVED':
        case 'AUTHORISED':
        case 'ENABLED':
        case 'ISSUED':
        case 'COMPLETED':
        case 'COMPLETE':
          this.backgroundColor.set('bg-green');
          this.textColor.set('text-white!');
          break;
        case 'ADJUSTED':
        case 'IN_PROGRESS':
        case 'INVITED':
        case 'PENDING':
        case 'PENDING_FOR_REVIEW':
        case 'SUBMITTED':
          this.backgroundColor.set('bg-orange');
          this.textColor.set('text-white!');
          break;
        case 'DISABLED':
          this.backgroundColor.set('bg-neut-87');
          this.textColor.set('text-charcoal-60!');
          break;
        case 'CANCELLED':
        case 'SUSPENDED':
        case 'REJECTED':
        case 'DECLINED':
          this.backgroundColor.set('bg-red');
          this.textColor.set('text-white!');
          break;
        default:
          this.backgroundColor.set('bg-charcoal-50');
          this.textColor.set('text-white!');
      }
    });
  }
}
